import * as angular from "angular";
import * as _ from 'lodash';
import {AnalyticsService} from "../../commons/services/analytics-service.service";
import {IQService} from "angular";
import {DeliveriesAlertsService} from "./deliveries-alerts.service";
import {DeliveriesDialogService} from "./deliveries-dialog-service.service";
import {DeliveriesRequestsService} from "./deliveries-requests.service";
import {DeliveriesService} from "./deliveries-service.service";
import {ServicesService} from "./services-service.service";
import {LeanPlanningRequestsService} from "../../lean-planning/services/plan-requests.factory";
import {
  CancellationReasonsDialogsService
} from "../../cancellation-reasons/services/cancellation-reasons-dialogs-service.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {CommonsDialogService} from "../../commons/services/commons-dialog.service";
import {ConfirmDialogService} from "../../commons/services/confirm-dialog.service";
import {PlanningDialogService} from "../../planning/services/planning-dialogs-service.service";
import {PlanningProjectsService} from "../../planning/services/planning-projects-service.service";
import {ServicesFacadeService} from "../angular/services/services-facade.service";
import {ActionReasonsDialogsServiceService} from "../../action-reasons/services/action-reasons-dialogs-service.service";
import {ActionReasonEntityEnum} from "../../action-reasons/enums/action-reason-entity.enum";
import {SiteFiltersType} from "../../commons/types/site-filters.type";
import {ServicesUpdateMetadataRequestModel} from "../models/services-update-metadata-request.model";
import {Service} from "../models/service.model";
import {SplitService} from "../../commons/services/split-service.service";
import {PrinterService} from "../../commons/services/printer-service.service";
import {OrdersService} from "../../orders/services/orders-service.service";

export class DeliveriesApiAction {

  private servicesRef: any;

  /* @ngInject */
  constructor(private $delivery, private $mdDialog, private DeliveriesAPI, private bringozLoaderService: BringozLoaderService, private $log,
              private $q: IQService, private leanPlanningRequestsService: LeanPlanningRequestsService, private ordersService: OrdersService,
              private confirmDialogService: ConfirmDialogService, private deliveriesDialogService: DeliveriesDialogService, private deliveriesRequestsService: DeliveriesRequestsService, private deliveriesAlertsService: DeliveriesAlertsService,
              private $filter, private analyticsService: AnalyticsService, private servicesService: ServicesService, private actionReasonsDialogsService: ActionReasonsDialogsServiceService,
              private deliveriesService: DeliveriesService, private agentRequests, private commonsDialogService: CommonsDialogService,
              private planningDialogService: PlanningDialogService, private planningProjectsService: PlanningProjectsService,
              private servicesFacadeService: ServicesFacadeService, private splitService: SplitService, private printerService: PrinterService) {
    this.servicesRef = this.$delivery();
  }

  cancel(ev, ids, serviceType) {
    return this.actionReasonsDialogsService.createCancelTaskReason(ids, ev, true, undefined, [ActionReasonEntityEnum.Delivery, ActionReasonEntityEnum.Operation])
      .then((payload) => {
        this.analyticsService.trackEvent('Deliveries Actions', 'Cancel', 'Confirm');
        const totalIds = _.concat(ids, payload.relatedServicesIds);

        return this.deliveriesService.cancelService(ev, totalIds, serviceType, payload.cancelReason);
      })
      .then((res) => {
        return this.$q.when(ids);
      })
      .catch((error) => {
        if (error) {
          this.analyticsService.trackEvent('Deliveries Actions', 'Cancel', 'Error');
          this.$log.error('Failed to create cancel reason', error);
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'Cancel', 'Cancel');
          this.$log.debug('Dialog Closed');
        }
      })

  }

  assignAgent(ev, ids) {
    let isRouted = false;
    return this.servicesRef.$asyncValues(ids)
      .then(services => {
        _.forEach(services, service => {
          if (service.routeId) {
            isRouted = true;
            return;
          }
        })
        return this.deliveriesDialogService.assignToAgent(ev, ids, isRouted);
      })
      .then((payload) => {
        this.analyticsService.trackEvent('Deliveries Actions', 'Assign', 'Confirm');
        this.bringozLoaderService.on();
        if (payload.relatedServicesIds.length) {
          ids = _.concat(ids, payload.relatedServicesIds);
        }

        return this.deliveriesRequestsService.assignToAgent(ids, payload.agentId, payload.doForce, false, payload.removeServiceFromRoute);
      })
      .then((res) => {
        this.servicesFacadeService.updateMany(res);
        if (ids.length > 1) {
          this.deliveriesAlertsService.assignManySuccess();
        } else {
          this.deliveriesAlertsService.assignSuccess();
        }
        return this.$q.when(ids);
      })
      .catch((error) => {
        if (error) {
          if (ids.length > 1) {
            this.deliveriesAlertsService.assignManyError(error);
          } else {
            this.deliveriesAlertsService.assignError(error);
          }
          this.$log.error('Failed to manually assign delivery', error);
          this.analyticsService.trackEvent('Deliveries Actions', 'Assign', 'Error');
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'Assign', 'Cancel');
          this.$log.debug('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  assignCanceledPickup(ev, ids) {
    let isRouted = false;
    let defaultAgentId;
    let selectedAgentName;
    let servicesList;
    return this.servicesRef.$asyncValues(ids)
      .then(services => {
        servicesList = services;
        defaultAgentId = _.get(services, '[0].agent.id');
        _.forEach(services, service => {
          if (service.routeId) {
            isRouted = true;
            return;
          }
        })
        const highPriorityAgentsIds = defaultAgentId ? [defaultAgentId] : undefined;
        return this.deliveriesDialogService.assignToAgent(ev, ids, isRouted, highPriorityAgentsIds);
      })
      .then((payload) => {
        this.analyticsService.trackEvent('Deliveries Actions', 'Assign', 'Confirm');
        this.bringozLoaderService.on();
        ids = _.concat(ids, payload.relatedServicesIds);
        selectedAgentName = `${_.get(payload.agent.user, 'firstName')} ${_.get(payload.agent.user, 'lastName')}`;
        return this.deliveriesRequestsService.reassignToAgent(ids, payload.agent.id, payload.doForce, false, payload.removeServiceFromRoute)
      })
      .then((res) => {
        this.servicesFacadeService.updateMany(res);
        if (ids.length > 1) {
          this.deliveriesAlertsService.assignAbortedPickupMultiSuccess(servicesList.length, selectedAgentName);
        } else {
          this.deliveriesAlertsService.assignAbortedPickupSuccess(servicesList[0].id, selectedAgentName);
        }
        return this.$q.when(ids);
      })
      .catch((error) => {
        if (error) {
          if (ids.length > 1) {
            this.deliveriesAlertsService.assignManyError(error);
          } else {
            this.deliveriesAlertsService.assignError(error);
          }
          this.$log.error('Failed to manually assign delivery', error);
          this.analyticsService.trackEvent('Deliveries Actions', 'Assign', 'Error');
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'Assign', 'Cancel');
          this.$log.debug('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  reassignCanceledDropoff(ev, ids) {

    return this.deliveriesRequestsService.reassignCanceledDropoff(ids)
      .then((payload) => {
        if (ids.length > 1) {
          this.deliveriesAlertsService.revertMultiSuccess(ids.length);
        } else {
          this.deliveriesAlertsService.revertSingleSuccess(ids[0])
        }
        return this.$q.when(ids);
      })
      .catch((error) => {
        if (error) {
          if (ids.length > 1) {
            this.deliveriesAlertsService.assignManyError();
          } else {
            this.deliveriesAlertsService.assignError();
          }
          this.$log.error('Failed to auto assign delivery', error);
          this.analyticsService.trackEvent('Deliveries Actions', 'AbortedAutoAssign', 'Error');
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'AbortedAutoAssign', 'Cancel');
          this.$log.debug('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

  }

  autoAssignAgent(ev, ids) {

    return this.servicesRef.$asyncValues(ids)
      .then((services) => {
        const relatedServiceIds = this.deliveriesService.getRelatedServicesByTypeMultiple(services, "SupplyTogether");
        if (!relatedServiceIds.length) {
          return this.$q.when({assignableServicesIds: []});
        }
        return this.deliveriesDialogService.autoAssignToAgentRelatedServices(ev, ids, relatedServiceIds);
      })
      .then((payload) => {

        if (payload.assignableServicesIds.length) {
          ids = _.concat(ids, payload.assignableServicesIds);
        }

        return this.deliveriesRequestsService.autoAssignAgent(ids)
          .then((res) => {
            if (ids.length > 1) {
              this.deliveriesAlertsService.autoAssignManySuccess();
            } else {
              this.deliveriesAlertsService.autoAssignSuccess();
            }
            return this.$q.when(ids);
          })
          .catch((error) => {
            if (error) {
              if (ids.length > 1) {
                this.deliveriesAlertsService.autoAssignManyError();
              } else {
                this.deliveriesAlertsService.autoAssignError();
              }
              this.$log.error('Failed to auto assign delivery', error);
              this.analyticsService.trackEvent('Deliveries Actions', 'AutoAssign', 'Error');
            } else {
              this.analyticsService.trackEvent('Deliveries Actions', 'AutoAssign', 'Cancel');
              this.$log.debug('Dialog Closed');
            }
          })
          .finally(() => {
            this.bringozLoaderService.off();
          });
      })
  }

  assignRoute(ev, ids) {
    return this.deliveriesDialogService.assignToRoute(ev, ids)
      .then((result) => {
        return this.$q.when(result.serviceIds);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to manually assign service to route', error);
          this.analyticsService.trackEvent('Deliveries Actions', 'Assign Route', 'Error');
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'Assign Route', 'Cancel');
          this.$log.debug('Dialog Closed');
        }
      })
  }

  assignResourceAllocation(ev, ids) {
    return this.deliveriesDialogService.assignToResourceAllocation(ev, ids)
      .then((result) => {
        return this.$q.when(result.serviceIds);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to manually assign service to resource allocation', error);
          // this.analyticsService.trackEvent('Deliveries Actions', 'Assign Route', 'Error');
        } else {
          // this.analyticsService.trackEvent('Deliveries Actions', 'Assign Route', 'Cancel');
          this.$log.debug('Dialog Closed');
        }
      })
  }

  manualHandle(event, ids, serviceType) {
    var id = _.castArray(ids)[0];
    return this.deliveriesDialogService.manualHandle(event, id)
      .then((payload: {note: string, relatedIds: string[]}) => {
        const serviceIds = _.concat(_.castArray(ids), payload.relatedIds);

        this.analyticsService.trackEvent('Deliveries Actions', 'ManualHandle', 'Confirm');
        this.bringozLoaderService.on();
        return this.deliveriesRequestsService.manualHandle(serviceIds, payload.note);
      })
      .then(() => {
        this.deliveriesAlertsService.manualHandledManySuccess();

        return this.$q.when(ids);
      })
      .catch((error) => {
        if (error) {
          this.deliveriesAlertsService.manualHandledManyError();
          this.$log.error('Failed to manually handled delivery', error);
          this.analyticsService.trackEvent('Deliveries Actions', 'ManualHandle', 'Error');
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'ManualHandle', 'Cancel');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  note(event, ids, serviceType) {
    return this.commonsDialogService.note(event, ids)
      .then((note) => {
        this.analyticsService.trackEvent('Deliveries Actions', 'ManualHandle', 'Confirm');
        this.bringozLoaderService.on();
        return this.deliveriesRequestsService.addNote(ids, note);
      })
      .then((res) => {
        this.servicesFacadeService.updateMany(res);
        this.deliveriesAlertsService.addNoteSuccess();
        return this.$q.when(ids);
      })
      .catch((error) => {
        if (error) {
          this.deliveriesAlertsService.addNoteError();
          this.$log.error('Failed to add note to service', error);
          this.analyticsService.trackEvent('Deliveries Actions', 'AddNote', 'Error');
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'AddNote', 'Cancel');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  bulkSMS(event, ids) {
    return this.deliveriesDialogService.bulkSMS(event, ids)
      .then((payload) => {
        this.analyticsService.trackEvent('Deliveries Actions', 'bulkSMS', 'Confirm');
        this.bringozLoaderService.on();
        return this.deliveriesRequestsService.bulkSMS(ids, payload.message, payload.type);
      })
      .then((res) => {
        this.deliveriesAlertsService.sendBulkSmsSuccess();
        return this.$q.when(ids);
      })
      .catch((error) => {
        if (error) {
          this.deliveriesAlertsService.sendBulkSmsError();
          this.$log.error('Failed to send bulk sms to services', error);
          this.analyticsService.trackEvent('Deliveries Actions', 'bulkSMS', 'Error');
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'bulkSMS', 'Cancel');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  reset(ev, ids, serviceType) {

    return this.deliveriesDialogService.reset(ev, ids, serviceType)
      .then((payload) => {
        const totalIds = _.concat(ids, payload.relatedServicesIds);

        this.analyticsService.trackEvent('Deliveries Actions', 'Reset', 'Confirm');
        this.bringozLoaderService.on();
        return this.servicesRef.$call(this.DeliveriesAPI.actions.reset, {
          ids: totalIds,
          removeFromRoute: payload.removeFromRoute
        }, {});
      })
      .then((res) => {
        this.servicesFacadeService.updateMany(res);
        this.deliveriesAlertsService.resetManySuccess();
        return this.$q.when(ids);
      })
      .catch((error) => {
        if (error) {
          this.deliveriesAlertsService.resetManyError(error);
          this.$log.error('Failed to reset delivery', error);
          this.analyticsService.trackEvent('Deliveries Actions', 'Reset', 'Error');
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'Reset', 'Cancel');
          this.$log.debug('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });


    //
    // let isRouted = false;
    // let text = ids.length > 1 ?
    //   this.$filter('translate')('CONFIRM_RESET_X_DELIVERIES', {value: ids.length}) :
    //   this.$filter('translate')('CONFIRM_RESET_DELIVERY_ID', {value: ids[0]});
    // return this.servicesRef.$asyncValues(ids).then(services => {
    //   _.forEach(services, service => {
    //     if (service.routeId) {
    //       isRouted = true;
    //       return;
    //     }
    //   })
    //   if (isRouted) {
    //     let actions;
    //     if (ids.length > 1) {
    //       actions = this.CommonsService.getConfirmActions(['Remove services from routes']);
    //     } else {
    //       actions = this.CommonsService.getConfirmActions(['Remove service from route']);
    //     }
    //     return this.confirmDialogService.confirmWithActions('Reset Delivery', text, actions, ev)
    //       .then((actionsResponse) => {
    //         this.analyticsService.trackEvent('Deliveries Actions', 'Reset', 'Confirm');
    //         this.bringozLoaderService.on();
    //         return this.servicesRef.$call(this.DeliveriesAPI.actions.reset, {
    //           ids: ids,
    //           removeFromRoute: actionsResponse[0].enabled
    //         }, {});
    //       })
    //       .then(() => {
    //         this.DeliveriesAlerts.resetManySuccess();
    //         return this.$q.when(ids);
    //       })
    //       .catch((error) => {
    //         if (error) {
    //           this.DeliveriesAlerts.resetManyError();
    //           this.$log.error('Failed to reset delivery', error);
    //           this.analyticsService.trackEvent('Deliveries Actions', 'Reset', 'Error');
    //         } else {
    //           this.analyticsService.trackEvent('Deliveries Actions', 'Reset', 'Cancel');
    //           this.$log.debug('Dialog Closed');
    //         }
    //       })
    //       .finally(() => {
    //         this.bringozLoaderService.off();
    //       });
    //   } else {
    //     const title = 'Reset Delivery';
    //
    //     return this.confirmDialogService.confirmWithActions('Reset Delivery', text, undefined, ev)
    //       .then(() => {
    //         this.analyticsService.trackEvent('Deliveries Actions', 'Reset', 'Confirm');
    //         this.bringozLoaderService.on();
    //         return this.servicesRef.$call(this.DeliveriesAPI.actions.reset, {ids: ids, removeFromRoute: false}, {});
    //       })
    //       .then(() => {
    //         this.DeliveriesAlerts.resetManySuccess();
    //         return this.$q.when(ids);
    //       })
    //       .catch((error) => {
    //         if (error) {
    //           this.DeliveriesAlerts.resetManyError();
    //           this.$log.error('Failed to reset delivery', error);
    //           this.analyticsService.trackEvent('Deliveries Actions', 'Reset', 'Error');
    //         } else {
    //           this.analyticsService.trackEvent('Deliveries Actions', 'Reset', 'Cancel');
    //           this.$log.debug('Dialog Closed');
    //         }
    //       })
    //       .finally(() => {
    //         this.bringozLoaderService.off();
    //       });
    //   }
    // })
  }

  sendToMarket(ev, ids, serviceType) {
    return this.$mdDialog.show({
      template: '<service-send-to-market-dialog aria-label="Delivery Send To Market" flex layout="column" ids="ids"></service-send-to-market-dialog>',
      parent: angular.element(document.body),
      controller: function ($scope) {
        $scope.ids = ids;
      },
      targetEvent: ev
    })
      .catch((error) => {
        if (error) {
          this.deliveriesAlertsService.sendToMarketError();
          this.$log.error('Failed to send to market', error);
        } else {
          this.$log.debug('Dialog Closed');
        }
      })
  }

  createRoute(ev, ids, serviceType) {

    return this.deliveriesDialogService.createRoute(ev, ids)
      .then((payload) => {
        this.analyticsService.trackEvent('Deliveries Actions', 'Route', 'Confirm');
        this.bringozLoaderService.on();
        return this.leanPlanningRequestsService.createRoute(payload)
      })
      .then((createdRoute) => {
        this.deliveriesAlertsService.createRoutesSuccess();
        return this.$q.when(ids);
      })
      .catch((error) => {
        if (error) {
          this.deliveriesAlertsService.createRoutesError();
          this.$log.error('Failed to create route', error);
          this.analyticsService.trackEvent('Deliveries Actions', 'Route', 'Error');
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'Route', 'Cancel');
          this.$log.debug('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  auction(ev, ids, serviceType) {
    const text = ids.length > 1 ?
      this.$filter('translate')('CONFIRM_SENDING_TO_AUCTION_X_DELIVERIES', {value: ids.length}) :
      this.$filter('translate')('CONFIRM_SENDING_TO_AUCTION_DELIVERY_ID', {value: ids[0]});

    return this.confirmDialogService.confirm('Send to Auction', text, ev)
      .then(() => {
        this.analyticsService.trackEvent('Deliveries Actions', 'Auction', 'Confirm');
        this.bringozLoaderService.on();
        return this.servicesRef.$call(this.DeliveriesAPI.actions.auction, {
          ids: ids
        })
      })
      .then((res) => {
        // this.servicesFacadeService.updateMany(res);
        if (ids.length > 1) {
          this.deliveriesAlertsService.auctionManySuccess();
        } else {
          this.deliveriesAlertsService.auctionSuccess();
        }
        return this.$q.when(ids);
      })
      .catch((error) => {
        if (error) {
          this.deliveriesAlertsService.auctionError();
          this.$log.error('Failed to send to auction', error);
          this.analyticsService.trackEvent('Deliveries Actions', 'Auction', 'Error');
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'Auction', 'Cancel');
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  editMetaData(ev, ids: string[]) {
    const metaData = this.splitService.getServicesMetadataSettings();
    return this.commonsDialogService.editMetaData(ev, ids, metaData)
      .then((res: { ids: string[], metaData: { key: string, value: string }[] }) => {
        const payload: ServicesUpdateMetadataRequestModel = {
          serviceIds: ids,
          metaData: res.metaData
        };

        this.analyticsService.trackEvent('Deliveries Actions', 'EditMetaData', 'Confirm');
        this.bringozLoaderService.on();
        return this.deliveriesService.updateServicesMetaData(payload)
      })
      .then((services: Service[]) => {
        // if (ids.length > 1) {
        //   this.deliveriesAlertsService.updateMetaDataSuccess();
        // } else {
        //   this.deliveriesAlertsService.updateMetaDataError();
        // }
        return this.$q.when(ids);
      })
      .catch((error) => {
        if (error) {
          this.deliveriesAlertsService.auctionError();
          this.$log.error('Failed to send to auction', error);
          this.analyticsService.trackEvent('Deliveries Actions', 'Auction', 'Error');
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'Auction', 'Cancel');
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  editTimeWindow(ev, ids) {
    let totalIds = ids;
    return this.deliveriesDialogService.editTimeWindow(ids, ev)
      .then((payloadRes) => {
        var payload = payloadRes.editData
        var rePrice = payloadRes.reprice
        var sendSms = payloadRes.sendSms

        this.analyticsService.trackEvent('Deliveries Actions', 'EditServiceTime', 'Confirm');

        totalIds = ids;
        if (payloadRes.editableServicesIds) {
          totalIds = _.concat(ids, payloadRes.editableServicesIds);
        }
        return this.servicesService.updateBulk(totalIds, payload, rePrice, sendSms);
      })
      .then((res) => {
        this.servicesFacadeService.updateMany(res);
        return this.$q.when(totalIds);
      })
      .catch((error) => {
        if (error) {
          this.analyticsService.trackEvent('Deliveries Actions', 'EditTimeWindow', 'Error');
        } else {
          this.analyticsService.trackEvent('Deliveries Actions', 'EditTimeWindow', 'Cancel');
        }
      })
  }

  editLocation(ev, serviceIds) {
    return this.deliveriesDialogService.bulkEditLocation(serviceIds, ev)
      .then((data) => {
        // const payload = {
        //   pickupTaskSpec: data.pickupTaskSpec,
        //   destinationTaskSpec: data.destinationTaskSpec
        // }

        const payload = {
          serviceIds: serviceIds,
          pickupTaskSpec: data.pickupTaskSpec,
          destinationTaskSpec: data.destinationTaskSpec,
          rePrice: data.rePrice,
          sendSms: data.sendSms,
          updateOrder: data.updateOrder,
        }


        return this.servicesService.bulkUpdateTaskSpec(payload);
      })
      .then((res) => {
        return this.$q.when(serviceIds);
      })
      .catch((error) => {
      })
  }

  sendToPlanning(ev, serviceIds, routeIds?) {
    let settings,
      reOptimize,
      services,
      takeResourcesFromRoute = false;
    return this.servicesRef.$asyncValues(serviceIds)
      .then((serviceList) => {
        services = serviceList;
        return this.planningDialogService.createProjectByServices(services, true, ev);
      })
      .then((settingsToCreate) => {
        settings = !_.isEmpty(settingsToCreate) ? settingsToCreate : undefined;

        let from;
        let to;
        let branchIds = [];

        _.forEach(services, (s) => {
          branchIds = _.uniq(branchIds.concat(s.branchIds || []))
          if (!from || from > s.notBefore) {
            from = s.notBefore;
          }
          if (!to || to < s.notAfter) {
            to = s.notAfter;
          }
        })

        return this.planningDialogService.selectAllocationResources(from, to, undefined, branchIds, undefined, {[SiteFiltersType.tags]: false}, false, ev)
      })
      .then((payload) => {
        this.planningProjectsService.servicePlanning(serviceIds, routeIds, settings, payload.selectedResources, reOptimize, takeResourcesFromRoute)
      })
      .then(() => {
        return this.$q.when(serviceIds);
      })
      .catch((error) => {

      })
  }


  edit(ev, ids) {
    const deferred = this.$q.defer();
    this.servicesRef.$asyncValues(ids)
      .then((deliveries) => {
        this.servicesService.onEditOne(deliveries[0], true);
        deferred.resolve(ids);
      });

    return deferred.promise;
  }

  editPackages(ev, ids) {
    const deferred = this.$q.defer();
    let serviceRef;
    this.servicesRef.$asyncValues(ids)
      .then((services) => {
        serviceRef = services[0];
        return this.ordersService.getOrderSettings(serviceRef.account.id, serviceRef.serviceType, serviceRef.pricePlanType)
      })
      .then((orderSettings) => {
        this.deliveriesDialogService.editPackages(serviceRef.packageList, orderSettings.itemSizeList, orderSettings.defaultItemSize)
          .then((updatedPackageList: any) => {
            const serviceCopy = angular.copy(serviceRef);
            serviceCopy.packageList = updatedPackageList;
            this.deliveriesService.updateService(serviceCopy, false)
              .then((updatedService) => {
                this.deliveriesAlertsService.updateDeliverySuccess(updatedService);
                deferred.resolve(ids);
              })
              .catch((error) => {
                this.deliveriesAlertsService.updateDeliveryError();
                deferred.reject(ids);
              })
          })
      })

    return deferred.promise;
  }

  print(ev, ids) {
    const deferred = this.$q.defer();
    this.servicesRef.$asyncValues(ids)
      .then((services) => {
        const hasDelivery = this.findIfServicesListHasDelivery(services);

        if (hasDelivery) {
          this.deliveriesDialogService.printDelivery()
            .then((purpose) => {
              this.servicesService.onPrint(ids, purpose);
            })
        } else {
          this.servicesService.onPrint(ids);
        }

        deferred.resolve(ids);
      })

    //must  return a promise with id's because of "deliveries-action-footer.component"
    return deferred.promise;


  }

  PrintLabel(ev, ids) {
    const deferred = this.$q.defer();
    this.servicesRef.$asyncValues(ids)
      .then((services) => {
        const service = _.last(services);
        this.printerService.printDelivery(service);
        deferred.resolve(ids);
      })

    return deferred.promise;
  }

  DownloadLabel(ev, ids) {
    const deferred = this.$q.defer();
    this.servicesRef.$asyncValues(ids)
      .then((services) => {
        const service = _.last(services);
        this.printerService.downloadDeliveryToPdf(service);
        deferred.resolve(ids);
      })

    return deferred.promise;
  }


  // ******************************
  // Internal methods
  // ******************************


  private findIfServicesListHasDelivery(list): boolean {
    return !!_.find(list, (s) => {
      return s.serviceType === "Delivery"
    })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .service('DeliveriesApiAction',
    DeliveriesApiAction
  );

